/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `pending` - Probíhá analýza * `ready` - Návrh připraven * `failed` - Analýza selhala * `confirmed` - Potvrzeno
 */
export type GradeBookClassificationStatusEnum = 'pending' | 'ready' | 'failed' | 'confirmed';

export const GradeBookClassificationStatusEnum = {
    Pending: 'pending' as GradeBookClassificationStatusEnum,
    Ready: 'ready' as GradeBookClassificationStatusEnum,
    Failed: 'failed' as GradeBookClassificationStatusEnum,
    Confirmed: 'confirmed' as GradeBookClassificationStatusEnum
};